import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import BreadcrumbNavigation from '../../components/BreadcrumbNavigation';
import QuickActionToolbar from '../../components/QuickActionToolbar';
import ReportParameterPanel from './components/ReportParameterPanel';
import ReportPreviewArea from './components/ReportPreviewArea';
import ReportTemplateLibrary from './components/ReportTemplateLibrary';
import ScheduledReportsManager from './components/ScheduledReportsManager';
import ExportOptionsModal from './components/ExportOptionsModal';
import SavedReportsBookmarks from './components/SavedReportsBookmarks';

import Button from '../../components/ui/Button';

const FinancialReportsGenerator = () => {
  const [parameters, setParameters] = useState({
    reportType: 'monthly-summary',
    period: 'current-month',
    startDate: '',
    endDate: '',
    client: 'all',
    category: ['all'],
    comparison: 'none',
    includeCharts: true,
    includeTables: true,
    includeSummary: true,
    showTrends: true
  });

  const [reportData, setReportData] = useState(null);
  const [isGenerating, setIsGenerating] = useState(false);
  const [showTemplateLibrary, setShowTemplateLibrary] = useState(false);
  const [showScheduledReports, setShowScheduledReports] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [showBookmarks, setShowBookmarks] = useState(false);

  useEffect(() => {
    document.title = 'Gerador de Relatórios - JR Wise Financial Control';
  }, []);

  const handleParameterChange = (field, value) => {
    setParameters(prev => ({ ...prev, [field]: value }));
  };

  const handleGenerateReport = () => {
    setIsGenerating(true);
    setTimeout(() => {
      setReportData({
        generated: true,
        timestamp: new Date()?.toISOString(),
        parameters: { ...parameters }
      });
      setIsGenerating(false);
    }, 1500);
  };

  const handleResetParameters = () => {
    setParameters({
      reportType: 'monthly-summary',
      period: 'current-month',
      startDate: '',
      endDate: '',
      client: 'all',
      category: ['all'],
      comparison: 'none',
      includeCharts: true,
      includeTables: true,
      includeSummary: true,
      showTrends: true
    });
    setReportData(null);
  };

  const handleSelectTemplate = (template) => {
    console.log('Selected template:', template);
    setParameters(prev => ({
      ...prev,
      reportType: template?.id
    }));
    setShowTemplateLibrary(false);
  };

  const handleExport = (exportOptions) => {
    console.log('Exporting report with options:', exportOptions);
    alert(`Relatório exportado com sucesso em formato ${exportOptions?.format?.toUpperCase()}!`);
  };

  const handleSchedule = () => {
    setShowScheduledReports(true);
  };

  const handleBookmark = () => {
    const bookmarkName = prompt('Digite um nome para este relatório:');
    if (bookmarkName) {
      console.log('Saving bookmark:', { name: bookmarkName, parameters });
      alert('Relatório salvo nos favoritos com sucesso!');
    }
  };

  const handleLoadBookmark = (bookmark) => {
    console.log('Loading bookmark:', bookmark);
    setParameters(prev => ({ ...prev, ...bookmark?.parameters }));
    setShowBookmarks(false);
    alert('Configuração carregada com sucesso!');
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <BreadcrumbNavigation />
      
      <main className="main-content">
        <div className="p-6 border-b border-border bg-card">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-bold text-foreground mb-2">Gerador de Relatórios Financeiros</h1>
              <p className="text-sm text-muted-foreground">
                Crie relatórios personalizados com análises detalhadas e visualizações interativas
              </p>
            </div>
            <div className="flex items-center gap-2">
              <Button
                variant="outline"
                size="sm"
                iconName="Bookmark"
                iconPosition="left"
                onClick={() => setShowBookmarks(true)}
              >
                Salvos
              </Button>
              <Button
                variant="outline"
                size="sm"
                iconName="Calendar"
                iconPosition="left"
                onClick={() => setShowScheduledReports(true)}
              >
                Agendados
              </Button>
              <Button
                variant="default"
                size="sm"
                iconName="Layout"
                iconPosition="left"
                onClick={() => setShowTemplateLibrary(true)}
              >
                Templates
              </Button>
            </div>
          </div>
        </div>

        <div className="flex h-[calc(100vh-240px)]">
          <div className="w-full lg:w-[30%] border-r border-border overflow-hidden">
            <ReportParameterPanel
              parameters={parameters}
              onParameterChange={handleParameterChange}
              onGenerateReport={handleGenerateReport}
              onResetParameters={handleResetParameters}
              isGenerating={isGenerating}
            />
          </div>

          <div className="w-full lg:w-[70%] overflow-hidden">
            <ReportPreviewArea
              reportData={reportData}
              onExport={() => setShowExportModal(true)}
              onSchedule={handleSchedule}
              onBookmark={handleBookmark}
            />
          </div>
        </div>
      </main>

      <QuickActionToolbar />

      {showTemplateLibrary && (
        <ReportTemplateLibrary
          onSelectTemplate={handleSelectTemplate}
          onClose={() => setShowTemplateLibrary(false)}
        />
      )}

      {showScheduledReports && (
        <ScheduledReportsManager
          onClose={() => setShowScheduledReports(false)}
        />
      )}

      {showExportModal && (
        <ExportOptionsModal
          onClose={() => setShowExportModal(false)}
          onExport={handleExport}
        />
      )}

      {showBookmarks && (
        <SavedReportsBookmarks
          onClose={() => setShowBookmarks(false)}
          onLoadBookmark={handleLoadBookmark}
        />
      )}
    </div>
  );
};

export default FinancialReportsGenerator;